import React from 'react';
import { View } from 'react-native';
import { Focusable, Icon, Text, User } from '..';
import { useStyleSheet, useThemeContext } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Fallback, Placeholder } from './components';
export function ProfileCard(props) {
    var _a;
    const { color } = useThemeContext();
    const styles = useStyleSheet(getStyles);
    if (props.isLoading)
        return React.createElement(Placeholder, { style: props.style });
    if (props.fallback)
        return React.createElement(Fallback, { style: props.style, onPress: props.onPress });
    const { image, locked, style, onPress, type, name, isSelected } = props;
    return (React.createElement(Focusable, { onPress: onPress, style: [styles.container, isSelected ? styles.selected : {}, style], hoverStyle: isSelected ? {} : (_a = props.hoverStyle) !== null && _a !== void 0 ? _a : styles.hover },
        locked ? (React.createElement(View, { style: styles.lockWrapper },
            React.createElement(Icon, { name: 'lock-closed', color: color.invert2.p56 }))) : null,
        React.createElement(View, { style: styles.wrapper },
            React.createElement(User, { size: 'lg', name: name, image: image, type: type }),
            React.createElement(Text, { type: 'headline', size: 'md', style: isSelected ? styles.selectedTitle : styles.title, numberOfLines: 1 }, name),
            React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.name }, type.charAt(0).toUpperCase() + type.substring(1)))));
}
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        paddingVertical: size.L - size.A,
        paddingHorizontal: size.G - size.A,
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'flex-start',
        borderRadius: size.G,
        backgroundColor: color.invert2.p4,
        borderWidth: size.A,
        borderColor: 'transparent'
    },
    selected: {
        backgroundColor: color.primary.ghost,
        borderColor: color.primary.solid
    },
    hover: { backgroundColor: color.invert2.p10 },
    wrapper: {
        width: 120,
        alignItems: 'center',
        justifyContent: 'center'
    },
    title: {
        marginTop: size.D
    },
    selectedTitle: {
        marginTop: size.D,
        color: color.primary.solid
    },
    name: { color: color.invert2.p56 },
    lockWrapper: { position: 'absolute', right: size.G, top: size.E }
}));
//# sourceMappingURL=index.js.map